import request, { ResponseData } from '@/utils/request'
import { TrainItem, TrainList, QuestionParam, AnwserParam, QuestionRequest } from './data.d'

export async function fetchTrainList(params): Promise<ResponseData<TrainList>> {
  // console.log(params);
  return request('/api/v1/training/task/list', {
    method: 'post',
    data: params,
  })
}

// 获取训练内容
export async function fetchGroups(params: TrainItem): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/group', {
    method: 'get',
  })
}

// 获取在职员工
export async function fetchEmployeeList(params): Promise<ResponseData<DetailList>> {
  return request('/api/v1/users/list', {
    method: 'post',
    data: params,
  })
}

// 根据分组id返回下面所有的案例
export async function fetchAllCasesTotal(params: string): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/list', {
    method: 'post',
    data: params,
  })
}

// 取上限
export async function fetchLimits(params: { group_id: string }): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/search', {
    method: 'post',
    data: params,
  })
}

// 开始训练
export async function startTrain(params: {
  task_id: string
  dialog_case_count?: number // 共接待
  concurrency?: number // 同时接待
}): Promise<ResponseData<null>> {
  // console.log('TrainItemdata', params)
  return request('/api/v1/training/chat/start', {
    method: 'post',
    data: params,
  })
}

// 发布和取消发布
export async function relAndCancelTrain(params: string): Promise<ResponseData<null>> {
  return request('/api/v1/training/task/status/modify', {
    method: 'post',
    data: params,
  })
}

// 批量创建训练
export async function createMany(params: TrainItem): Promise<ResponseData<null>> {
  return request('/api/v1/training/task/modify', {
    method: 'post',
    data: params,
  })
}

// 检测名字是否存在
export async function exitTrainName(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/task/exits', {
    method: 'post',
    data: params,
  })
}

// 删除训练
export async function deleteTrain(params: TrainItem): Promise<ResponseData<null>> {
  return request('/api/v1/training/task/remove', {
    method: 'post',
    data: params,
  })
}

// 客服回答上传、获取下一条顾客消息
export const fetchNextMessage = (values: any): Promise<any> => {
  return request(`/api/v1/training/chat/answer`, {
    method: 'post',
    data: values,
  })
}

export const fetchQuestion = (values: QuestionParam) => {
  const { task_id, dialog_case_id, ai_buyer_story_id, type } = values
  return request(`/api/v1/training/chat/question`, {
    method: 'post',
    data: { task_id, dialog_case_id, ai_buyer_story_id, type },
  })
}
export const fetchAnwser = (values: AnwserParam) => {
  const {
    task_id,
    index,
    answer,
    dialog_case_id = '',
    ai_buyer_story_id = '',
    robot_answer,
  } = values
  let data = {}
  if (ai_buyer_story_id) {
    data = { task_id, ai_buyer_story_id, answer, robot_answer }
  } else if (dialog_case_id) {
    data = { task_id, dialog_case_id, answer, robot_answer }
  } else {
    data = { task_id, index, answer, robot_answer }
  }

  if (answer.includes('desc')) {
    data.answer_type = 1
  }

  return request(`/api/v1/training/chat/answer`, {
    method: 'post',
    data,
  })
}

export const lunxunDialogList = (values) => {
  return request(`/api/v1/training/chat/dialog_list`, {
    method: 'post',
    data: values,
  })
}

// 获取标签 list
export function tagList(params) {
  return request('/api/v1/users/tags/list', {
    method: 'post',
    data: params,
  })
}

// 根据标签id查user list
export function usersByTag(params) {
  return request('/api/v1/users/tags/users', {
    method: 'post',
    data: params,
  })
}

// tag list 且带上tag包含的user
export function tagsAndUsers(params) {
  return request('/api/v1/users/tags/tag_users', {
    method: 'post',
    data: params,
  })
}

// 获取会话分组的
export function phraseGroup(params) {
  return request('/api/v1/sys/phrase/group', {
    method: 'post',
    data: params,
  })
}

// 获取质检标准信息
export function getNorms() {
  return request('/api/v1/sys/norms', {
    method: 'post',
  })
}

// 获取所有的AI剧情
export function getAllStories() {
  return request('/api/v1/training/storycase/story_group/list', {
    method: 'post',
  })
}

// 训练结果会话评价
export function evalTraining(params) {
  return request('/api/v1/training/dialog_result/eval', {
    method: 'post',
    data: params,
  })
}

// 体验页面训练结果会话评价
export function evalTraining_experince(params) {
  return request('/api/v1/trial_training/dialog_result/eval', {
    method: 'post',
    data: params,
    headers: {
      'Trial-Id': localStorage.getItem('trial_id'),
    },
  })
}

// 编辑模拟订单
export function editSimulatedOrder(params) {
  return request('/api/v1/training/dialog_result/simulated_order/update', {
    method: 'post',
    data: params,
  })
}

// 查询模拟订单信息
export function searchSimulatedOrder(params) {
  return request('/api/v1/training/dialog_result/simulated_order/query', {
    method: 'post',
    data: params,
  })
}

// 模拟订单评价
export function evalMockOrder(params) {
  return request('/api/v1/sys/eval/save', {
    method: 'post',
    data: params,
  })
}

// 接待设置快捷短语查询
export function taskShortFind(params) {
  return request('/api/v1/training/task/find', {
    method: 'post',
    data: params,
  })
}

// 手动结束会话任务
export function manualFinishReception(params): Promise<ResponseData<QuestionRequest>> {
  return request('/api/v1/training/chat/finish_pipline', {
    method: 'post',
    data: params,
  })
}

// 结束会话后调用以让后端关闭会话
export function finishChat(params): Promise<ResponseData<QuestionParam>> {
  return request('/api/v1/training/chat/finish_chat', {
    method: 'post',
    data: params,
  })
}
